import { ConfigTenantInformedConsentFormV1 } from '@csp/dmdp-api-informed-consent-dto';
import { IcfConfig } from '../model/IcfConfig';

const from = (configTenantInformedConsentFormV1: ConfigTenantInformedConsentFormV1): IcfConfig => ({
  version: configTenantInformedConsentFormV1.version,
  masterLanguageCode: configTenantInformedConsentFormV1.data.masterLanguageCode,
  icfTypes: configTenantInformedConsentFormV1.data.icfTypes,
  icfSamples: configTenantInformedConsentFormV1.data.icfSamples,
});

export const IcfConfigMapper = {
  from,
};
